import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';

export const svgPaths: { [key in TcddSubSystem]: string } = {
  [TcddSubSystem.MAIN_SYSTEM]: '',
  [TcddSubSystem.TEXT_SYSTEM]: '',
  [TcddSubSystem.TRACTION_SYSTEM]: 'assets/images/train/train-traction',
  [TcddSubSystem.SIGNALIZATION_SYSTEM]: 'assets/images/train/train-signalization',
  [TcddSubSystem.COMMUNICATION_SYSTEM]: 'assets/images/train/train-communication',
  [TcddSubSystem.BRAKE_SYSTEM]: 'assets/images/train/train-brake',
  [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: 'assets/images/train/train-powervoltage',
  [TcddSubSystem.AIR_CONDITION_SYSTEM]: 'assets/images/train/train-aircondition',
  [TcddSubSystem.DOOR_SYSTEM]: 'assets/images/train/train-door',
  [TcddSubSystem.OTHER_SYSTEM]: 'assets/images/train/train-other',
};

// Mapping for vacuum statuses.
export const vacuumMap: { [key: string]: string } = {
  '1': 'cutter_opened',
  '2': 'cutter_open_failed',
  '3': 'cutter_not_ready',
  '4': 'cutter_ska1_closed',
  '5': 'cutter_ska2_closed',
  '6': 'cutter_commission_failed',
  '7': 'cutter_cannot_be_commissioned'
};

// Mapping for pantograph statuses.
export const pantographMap: { [key: string]: string } = {
  '1': 'pantograph_lower_failed',
  '2': 'ska1_pantograph_raised',
  '3': 'ska2_pantograph_raised',
  '4': 'ska1_pantograph_raise_failed',
  '5': 'ska2_pantograph_raise_failed',
  '6': 'ska1_pantograph_lowered',
  '7': 'ska2_1b_pantograph_lowered',
  '8': 'ska1_pantograph_raised_and_powered',
  '9': 'ska2_pantograph_raised_and_powered',
  '10': 'pantograph_cannot_be_raised',
  '11': 'ska1_pantograph_cannot_be_lowered',
  '12': 'ska2_pantograph_cannot_be_lowered'
};

// Mapping for hvac mode.
export const hvacMode: { [key: string]: string } = {
  '1': 'hvac-inhibition',
  '2': 'closed-mode',
  '3': 'automatic-mode',
  '4': 'manual-mode',
  '5': 'spring-autumn-mode',
  '6': 'reduced-mode',
  '7': 'stand-by-mode',
  '8': 'ventilation-mode'
};

export const brakeMode: { [key: string]: string } = {
  '0': 'freight_brake_mode_selected',
  '1': 'passenger_brake_mode_selected'
};

export const dmiStatus: { [key: string]: string } = {
  '1': 'dmi_operating_mode',
  '2': 'dmi_startup_mode',
  '3': 'dmi_is_not_working',
  '4': 'the_train_exceeded_the_maximum_speed'
};

// Headers for train coupling.
export const couplingHeaders: any = [
  {name: 'primaryTrain'},
  {name: 'secondaryTrain'}
];

// Mapping for interior lighting modes.
export const interiorLightingModes: any = [
  {label: 'lightOff', iconPath: 'assets/images/train/unit-lightOff.svg'},
  {label: 'halfLight', iconPath: 'assets/images/train/unit-halfLight.svg'},
  {label: 'lightOn', iconPath: 'assets/images/train/unit-lightOn.svg'},
  {label: 'emergencyLight', iconPath: 'assets/images/train/unit-emergencyLight.svg'}
];

export const iconMap: Record<string, { match: string; notMatch: string }> = {
  'error': {match: 'fa fa-times-circle text-danger', notMatch: 'fa fa-check-circle text-success'},
  'warning': {match: 'fa fa-exclamation-triangle text-warning', notMatch: 'fa fa-check-circle text-success'},
  'info': {match: 'fa fa-info-circle text-info', notMatch: 'fa fa-check-circle text-success'}
};

export const badgeMap: Record<string, { match: string; notMatch: string }> = {
  'active': {match: 'active', notMatch: 'inactive'},
  'engaged': {match: 'engaged', notMatch: 'disengaged'},
  'isolated': {match: 'isolated', notMatch: 'not-isolated'},
  'sos': {match: 'sos', notMatch: 'not-sos'},
  'pantograph-up': {match: 'pantograph-up', notMatch: 'pantograph-down'},
  'open': {match: 'open', notMatch: 'close'},
  'detected': {match: 'detected', notMatch: 'not-detected'},
  'applied': {match: 'applied', notMatch: 'not-applied'},
  'emergency-brake-free': {match: 'emergency-brake-free', notMatch: 'emergency-brake-applied'},
  'sent': {match: 'sent', notMatch: 'not-sent'},
  'ready': {match: 'ready', notMatch: 'not-ready'}
};

export const textMap: Record<string, { match: string; notMatch: string }> = {
  'open': {match: 'Open', notMatch: 'Closed'},
  'enabled': {match: 'enabled', notMatch: 'disabled'}
};

export const svgMap: Record<string, { match: string; notMatch: string }> = {
  'svg-warning': {match: 'warning.svg', notMatch: 'ok.svg'},
  'svg-not-ok': {match: 'not-ok.svg', notMatch: 'ok.svg'},
  'svg-point-red': {match: 'point-red.svg', notMatch: 'point-green.svg'},
  'svg-brake': {match: 'unit-brake-green.svg', notMatch: 'unit-brake-gray.svg'},
  'svg-parkingBrake-1': {match: 'unit-parkingBrake-gray.svg', notMatch: 'unit-parkingBrake-white.svg'},
  'svg-parkingBrake-2': {match: 'unit-parkingBrake-red.svg', notMatch: 'unit-parkingBrake-white.svg'},
  'svg-emergencyBrake': {match: 'unit-emergencyBrake-red.svg', notMatch: 'unit-emergencyBrake-gray.svg'}
};
